import { useCallback } from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import CountersigningRequestModal from './OpenModalCountersignLeaseExtension/CountersigningRequestModal';
import LeaseExtension from '../../../models/LeaseExtension';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

export default function OpenModalCountersignLeaseExtension({
  lease,
  property,
  history,
  terminateActiveAction,
}: LeaseActionProps) {
  const { renewalId, leaseId } = useLeasingUrlParams();
  const latestExtension = lease?.latestExtension ?? null;

  const extensionId = renewalId || latestExtension?.id || '';

  const startSigning = useCallback(() => {
    terminateActiveAction();
    history.push(LeaseExtension.getPreviewPath(leaseId || lease.id, extensionId));
  }, [lease, history, terminateActiveAction, extensionId, leaseId]);

  return (
    <CountersigningRequestModal
      propertyAddress={property ? property.streetAddress : ''}
      onClose={terminateActiveAction}
      startSigning={startSigning}
    />
  );
}
